import { consentNavigationItems, consentRoutes } from "./router";
/**
 * Consent Module — admin surface for the OPINK tenant consent matrix.
 */
export class ConsentModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ConsentModule] Registered");
        return {
            id: "consent",
            name: "Consent Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return consentRoutes;
    }
    getNavigationItems() {
        return consentNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ConsentModule] Unregistered");
        this.contracts = null;
    }
}
export default new ConsentModule();
